import { render, staticRenderFns } from "./AIChatMessages.vue?vue&type=template&id=224df678&scoped=true&"
import script from "./AIChatMessages.vue?vue&type=script&lang=js&"
export * from "./AIChatMessages.vue?vue&type=script&lang=js&"
import style0 from "./AIChatMessages.vue?vue&type=style&index=0&id=224df678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224df678",
  null
  
)

export default component.exports